var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filter" }, [
    _c("div", { staticClass: "section section--filter" }, [
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "form",
            {
              staticClass:
                "form form--filter form--filter-vehicles large-width",
              attrs: { action: "#" },
              on: { submit: _vm.formSubmitHandler }
            },
            [
              _vm.isContentReady
                ? _c("div", [
                    _c("div", { staticClass: "filters" }, [
                      _c(
                        "div",
                        { staticClass: "field-group field-group--select" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "label label--select",
                              attrs: { for: "selectedBrand" }
                            },
                            [_vm._v(_vm._s(_vm.lexicon.brand))]
                          ),
                          _vm._v(" "),
                          _vm.isMobileAndTouch
                            ? [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedBrand,
                                        expression: "selectedBrand"
                                      }
                                    ],
                                    staticClass: "select",
                                    class: [
                                      {
                                        "select--dark":
                                          _vm.selectedBrand !== "*"
                                      }
                                    ],
                                    attrs: {
                                      name: "selectedBrand",
                                      id: "selectedBrand"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.selectedBrand = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  _vm._l(_vm.brands, function(item) {
                                    return _c(
                                      "option",
                                      { domProps: { value: item.term_id } },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  0
                                )
                              ]
                            : [
                                _vm.brands && _vm.brands.length > 0
                                  ? _c("multiselect", {
                                      staticClass:
                                        "multiselect--small multiselect--regular",
                                      class: [
                                        {
                                          "select--dark":
                                            _vm.selectedBrand !== "*"
                                        }
                                      ],
                                      attrs: {
                                        options: _vm.brands,
                                        id: "selectedBrand",
                                        label: "name",
                                        placeholder: _vm.lexicon.all,
                                        "track-by": "term_id"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "singleLabel",
                                            fn: function(ref) {
                                              var option = ref.option
                                              return [
                                                _vm._v(_vm._s(option.name))
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        2705703343
                                      ),
                                      model: {
                                        value: _vm.selectedBrandObject,
                                        callback: function($$v) {
                                          _vm.selectedBrandObject = $$v
                                        },
                                        expression: "selectedBrandObject"
                                      }
                                    })
                                  : _vm._e()
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "field-group field-group--select" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "label label--select",
                              attrs: { for: "selectedModel" }
                            },
                            [_vm._v(_vm._s(_vm.lexicon.model))]
                          ),
                          _vm._v(" "),
                          _vm.isMobileAndTouch
                            ? [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedModel,
                                        expression: "selectedModel"
                                      }
                                    ],
                                    staticClass: "select",
                                    class: [
                                      {
                                        "select--dark":
                                          _vm.selectedModel !== "*"
                                      }
                                    ],
                                    attrs: {
                                      name: "selectedModel",
                                      id: "selectedModel"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.selectedModel = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  _vm._l(_vm.availableModels, function(item) {
                                    return _c(
                                      "option",
                                      { domProps: { value: item.id } },
                                      [_vm._v(_vm._s(item.model))]
                                    )
                                  }),
                                  0
                                )
                              ]
                            : [
                                _vm.availableModels &&
                                _vm.availableModels.length > 0
                                  ? _c("multiselect", {
                                      staticClass:
                                        "multiselect--small multiselect--regular",
                                      class: [
                                        {
                                          "select--dark":
                                            _vm.selectedModel !== "*"
                                        }
                                      ],
                                      attrs: {
                                        options: _vm.availableModels,
                                        id: "selectedModel",
                                        label: "model",
                                        placeholder: _vm.lexicon.all,
                                        "track-by": "id"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "singleLabel",
                                            fn: function(ref) {
                                              var option = ref.option
                                              return [
                                                _vm._v(_vm._s(option.model))
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1114889159
                                      ),
                                      model: {
                                        value: _vm.selectedModelObject,
                                        callback: function($$v) {
                                          _vm.selectedModelObject = $$v
                                        },
                                        expression: "selectedModelObject"
                                      }
                                    })
                                  : _vm._e()
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "field-group field-group--select" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "label label--select",
                              attrs: { for: "selectedType" }
                            },
                            [_vm._v(_vm._s(_vm.lexicon.vehicle_type))]
                          ),
                          _vm._v(" "),
                          _vm.isMobileAndTouch
                            ? [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedType,
                                        expression: "selectedType"
                                      }
                                    ],
                                    staticClass: "select",
                                    class: [
                                      {
                                        "select--dark": _vm.selectedType !== "*"
                                      }
                                    ],
                                    attrs: {
                                      name: "selectedType",
                                      id: "selectedType"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.selectedType = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  _vm._l(_vm.availableTypes, function(item) {
                                    return _c(
                                      "option",
                                      { domProps: { value: item.term_id } },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  0
                                )
                              ]
                            : [
                                _vm.availableTypes &&
                                _vm.availableTypes.length > 0
                                  ? _c("multiselect", {
                                      staticClass:
                                        "multiselect--small multiselect--regular",
                                      class: [
                                        {
                                          "select--dark":
                                            _vm.selectedType !== "*"
                                        }
                                      ],
                                      attrs: {
                                        options: _vm.availableTypes,
                                        id: "selectedType",
                                        label: "name",
                                        placeholder: _vm.lexicon.all,
                                        "track-by": "term_id"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "singleLabel",
                                            fn: function(ref) {
                                              var option = ref.option
                                              return [
                                                _vm._v(_vm._s(option.name))
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        2705703343
                                      ),
                                      model: {
                                        value: _vm.selectedTypeObject,
                                        callback: function($$v) {
                                          _vm.selectedTypeObject = $$v
                                        },
                                        expression: "selectedTypeObject"
                                      }
                                    })
                                  : _vm._e()
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "field-group field-group--select" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "label label--select",
                              attrs: { for: "selectedBranch" }
                            },
                            [_vm._v(_vm._s(_vm.lexicon.location))]
                          ),
                          _vm._v(" "),
                          _vm.isMobileAndTouch
                            ? [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedBranch,
                                        expression: "selectedBranch"
                                      }
                                    ],
                                    staticClass: "select",
                                    class: [
                                      {
                                        "select--dark":
                                          _vm.selectedBranch !== "*"
                                      }
                                    ],
                                    attrs: {
                                      name: "selectedBranch",
                                      id: "selectedBranch"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.selectedBranch = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  _vm._l(_vm.availableBranches, function(item) {
                                    return _c(
                                      "option",
                                      { domProps: { value: item.term_id } },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  0
                                )
                              ]
                            : [
                                _vm.availableBranches &&
                                _vm.availableBranches.length > 0
                                  ? _c("multiselect", {
                                      staticClass:
                                        "multiselect--small multiselect--regular",
                                      class: [
                                        {
                                          "select--dark":
                                            _vm.selectedBranch !== "*"
                                        }
                                      ],
                                      attrs: {
                                        options: _vm.availableBranches,
                                        id: "selectedBranch",
                                        label: "name",
                                        placeholder: _vm.lexicon.all,
                                        "track-by": "term_id"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "singleLabel",
                                            fn: function(ref) {
                                              var option = ref.option
                                              return [
                                                _vm._v(_vm._s(option.name))
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        2705703343
                                      ),
                                      model: {
                                        value: _vm.selectedBranchObject,
                                        callback: function($$v) {
                                          _vm.selectedBranchObject = $$v
                                        },
                                        expression: "selectedBranchObject"
                                      }
                                    })
                                  : _vm._e()
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "field-group field-group--select" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "label label--select",
                              attrs: { for: "selectedFuelType" }
                            },
                            [_vm._v(_vm._s(_vm.lexicon.fuel))]
                          ),
                          _vm._v(" "),
                          _vm.isMobileAndTouch
                            ? [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedFuelType,
                                        expression: "selectedFuelType"
                                      }
                                    ],
                                    staticClass: "select",
                                    class: [
                                      {
                                        "select--dark":
                                          _vm.selectedFuelType !== "*"
                                      }
                                    ],
                                    attrs: {
                                      name: "selectedFuelType",
                                      id: "selectedFuelType"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.selectedFuelType = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  _vm._l(_vm.availableFuelTypes, function(
                                    item
                                  ) {
                                    return _c(
                                      "option",
                                      { domProps: { value: item.slug } },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  0
                                )
                              ]
                            : [
                                _vm.availableFuelTypes &&
                                _vm.availableFuelTypes.length > 0
                                  ? _c("multiselect", {
                                      staticClass:
                                        "multiselect--small multiselect--regular",
                                      class: [
                                        {
                                          "select--dark":
                                            _vm.selectedFuelType !== "*"
                                        }
                                      ],
                                      attrs: {
                                        options: _vm.availableFuelTypes,
                                        id: "selectedFuelType",
                                        label: "name",
                                        placeholder: _vm.lexicon.all,
                                        "track-by": "slug"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "singleLabel",
                                            fn: function(ref) {
                                              var option = ref.option
                                              return [
                                                _vm._v(_vm._s(option.name))
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        2705703343
                                      ),
                                      model: {
                                        value: _vm.selectedFuelTypeObject,
                                        callback: function($$v) {
                                          _vm.selectedFuelTypeObject = $$v
                                        },
                                        expression: "selectedFuelTypeObject"
                                      }
                                    })
                                  : _vm._e()
                              ]
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _vm.selectedModel === "*" &&
                    this.minWeight !== this.maxWeight
                      ? _c(
                          "div",
                          { staticClass: "field-group field-group--range" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "label label--select",
                                attrs: { for: "weightInput" }
                              },
                              [_vm._v(_vm._s(_vm.lexicon.total_weight))]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "input-range__value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.lexicon.from +
                                    " " +
                                    parseFloat(
                                      _vm.selectedRangeWeight[0] / 1000
                                    )
                                      .toFixed(1)
                                      .replace(".0", "") +
                                    " " +
                                    _vm.lexicon.until.toLowerCase() +
                                    " " +
                                    _vm.convertWeightToTons(
                                      _vm.selectedRangeWeight[1]
                                    )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("vue-slider", {
                              attrs: {
                                min: _vm.minWeight,
                                max: _vm.maxWeight,
                                height: 11,
                                step: "100",
                                "tooltip-formatter": _vm.weightFormatter
                              },
                              model: {
                                value: _vm.selectedRangeWeight,
                                callback: function($$v) {
                                  _vm.selectedRangeWeight = $$v
                                },
                                expression: "selectedRangeWeight"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "input-range__min" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.convertWeightToTons(_vm.minWeight, true)
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "input-range__max" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.convertWeightToTons(_vm.maxWeight, true)
                                )
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "action action--underline action--reset",
                        on: { click: _vm.resetFilters }
                      },
                      [
                        _c("span", { staticClass: "action__text" }, [
                          _vm._v(_vm._s(_vm.lexicon.filter_reset))
                        ])
                      ]
                    )
                  ])
                : [
                    _c("content-loader", {
                      attrs: {
                        height: 219,
                        width: 1050,
                        speed: 2,
                        primaryColor: "#f3f3f3",
                        secondaryColor: "#ecebeb"
                      }
                    })
                  ]
            ],
            2
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "section section--results" }, [
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "container" }, [
          _vm.isContentReady
            ? _c(
                "div",
                { staticClass: "row row--grid" },
                _vm._l(_vm.selectionPaginated, function(item) {
                  return _c(
                    "a",
                    {
                      staticClass: "col-sm-12 col-md-12 col-lg-6 teaser",
                      attrs: { href: item.link }
                    },
                    [
                      item.feature
                        ? _c("figure", [
                            _c("picture", [
                              _vm.isWebpEnable
                                ? _c("source", {
                                    attrs: { srcset: item.feature[0] }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("img", {
                                attrs: {
                                  src: _vm.isWebpEnable
                                    ? item.feature[0].replace(".jpg", ".webp")
                                    : item.feature[0],
                                  width: item.feature[1],
                                  height: item.feature[2],
                                  loading: "lazy",
                                  alt: item.post_title
                                }
                              })
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "teaser__content" }, [
                        _c(
                          "p",
                          { staticClass: "title--small teaser__suptitle" },
                          [_vm._v(_vm._s(item.types[0].name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "h3",
                          { staticClass: "teaser__title font-weight-bold" },
                          [
                            item.brand[0]
                              ? _c("span", [_vm._v(_vm._s(item.brand[0].name))])
                              : _vm._e(),
                            _vm._v("\n                  " + _vm._s(item.model))
                          ]
                        ),
                        _vm._v(" "),
                        item.price_from
                          ? _c("p", { staticClass: "teaser__price" }, [
                              _vm._v(
                                _vm._s(_vm.lexicon.from) +
                                  "\n                  "
                              ),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.convertToCurrency(item.price_from)
                                  )
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("dl", { staticClass: "teaser__descriptions" }, [
                          item.payload_up_to
                            ? _c(
                                "div",
                                { staticClass: "teaser__descriptions-item" },
                                [
                                  _c("dt", [
                                    _vm._v(_vm._s(_vm.lexicon.payload_up_to))
                                  ]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatWeight(item.payload_up_to)
                                      ) + " kg"
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.towable_load_up_to
                            ? _c(
                                "div",
                                { staticClass: "teaser__descriptions-item" },
                                [
                                  _c("dt", [
                                    _vm._v(
                                      _vm._s(_vm.lexicon.towable_load_up_to)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatWeight(
                                          item.towable_load_up_to
                                        )
                                      ) + " kg"
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.seats
                            ? _c(
                                "div",
                                { staticClass: "teaser__descriptions-item" },
                                [
                                  _c("dt", [_vm._v(_vm._s(_vm.lexicon.seats))]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        "" +
                                          (item.seats_minimum
                                            ? item.seats_minimum + "-"
                                            : "") +
                                          item.seats
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ]
                  )
                }),
                0
              )
            : _c(
                "div",
                { staticClass: "row row--grid" },
                _vm._l(10, function(i) {
                  return _c("content-loader", {
                    key: i,
                    staticClass:
                      "col col-sm-12 col-md-12 col-lg-6 teaser teaser--loader",
                    attrs: {
                      height: 775,
                      width: 761,
                      speed: 2,
                      primaryColor: "#f3f3f3",
                      secondaryColor: "#ecebeb"
                    }
                  })
                }),
                1
              ),
          _vm._v(" "),
          _vm.selection.length > this.selectionPaginated.length
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "action__container action__container--center"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "action action--button",
                        on: { click: _vm.showMore }
                      },
                      [
                        _c("span", { staticClass: "action__text" }, [
                          _vm._v(_vm._s(_vm.lexicon.show_more))
                        ])
                      ]
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.selectionPaginated && _vm.selectionPaginated.length === 0
            ? _c("div", { staticClass: "row row--grid" }, [
                _c(
                  "div",
                  {
                    staticClass: "col col-sm-12 col-md-12 offset-lg-2 col-lg-8"
                  },
                  [
                    _c("div", {
                      staticClass: "body",
                      domProps: { innerHTML: _vm._s(_vm.lexicon.no_result) }
                    })
                  ]
                )
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }